export default __webpack_public_path__ + "static/media/navbar-icon-home.9f9a3d2f.svg";